
import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import HorizontalCard from '../HorizontalCard';
import { Grid } from '@mui/material';

const HorizontalCardsList = (props) => {
    const { rows: data, onSelect, multiple = false } = props;

    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    useEffect(() => {
        if (onSelect) {
            onSelect(selected);
        }
    }, [selected]);

    const handleClick = (item) => {
        if (!multiple) {
            setSelected(item.id);
            return;
        }
        
        const selectedIndex = selected.indexOf(item.id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, item.id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const isSelected = (name) => selected.indexOf(name) !== -1;

    return (
        <Box sx={{ width: '100%' }}>
            <Grid container spacing={2}>
                {
                    data?.map(item => (
                        <Grid key={item.id} item xs={12}>
                            <HorizontalCard
                                selected={isSelected(item.id)}
                                item={{
                                    title: item?.title || '',
                                    description: item?.description || '',
                                    url: item.imageUrl || '',
                                    data: item.data
                                }}
                                footerAction={null}
                                {
                                    ...(
                                        onSelect ?
                                        {
                                            handleClick: (value) => handleClick(value),
                                            url: null,
                                        } :
                                        {
                                            url: item.url,
                                            handleClick: () => {},
                                        }
                                    )
                                }
                            />
                        </Grid>
                    ))
                }
            </Grid>
        </Box>
    );
}

export default HorizontalCardsList;
